import { PanelVm, IPanelInitializer } from "./panel-vm";
import { dx } from "../devexpress/ui-options-types-wrapper";
import { Logger } from "../logger/logger";
import { ControlType } from "../devexpress/controltype";
import { KoExtend } from "../extend/knockout-extend";

export interface PopupCancelOptions {
	onClick: (e: any) => void;
	text?: string;
}

export abstract class PopupPanelVm extends PanelVm {
	constructor(init?: IPanelInitializer) {
		super(init);

		this.isVisible.subscribe((val) => {
			if (val) {
				this.initialize();
			}
		});

		if (Logger.isEnabled()) {
			Promise.resolve().then(() => {
				if (this.popupOptions == null || Object.keys(this.popupOptions).length === 0) {
					Logger.warn(`Did you forget to call 'applyPopupOptions()' in class ${this.constructor.name}?`);
				}
			});
		}
	}

	public isVisible: KnockoutObservable<boolean> = ko.observable(false);
	public fullScreen: KnockoutObservable<boolean> = ko.observable(false);
	public popupOptions: dx.PopupOptions = {};
	public isRunning: KnockoutObservable<boolean> = ko.observable(false);
	public cancelOptions: PopupCancelOptions = {
		onClick: (e: any) => {
			this.onCancel();
			this.hide();
		},
		text: "Abbrechen"
	};

	public title: KnockoutObservable<string> = ko.observable("Auswahldialog");

	public applyPopupOptions(options: dx.PopupOptions) {
		if (options == null) {
			options = {};
		}

		let orgTitle = options.title;
		options.title = this.title;
		if (orgTitle != null) {
			if (ko.isObservable(orgTitle)) {
				// bind title
				(orgTitle as KnockoutObservable<string>).subscribe((newValue) => {
					this.title(newValue);
				});
				this.title(KoExtend.resolve(orgTitle));
			} else {
				this.title(orgTitle);
			}
		}

		if (options.width == null) {
			options.width = "auto";
		}

		if (options.height == null) {
			options.height = "auto";
		}

		if (options.fullScreen == null) {
			options.fullScreen = this.fullScreen;
		}

		if (options.resizeEnabled == null) {
			options.resizeEnabled = true;
		}

		if (options.toolbarItems == null) {
			options.toolbarItems = [
				{
					toolbar: "top",
					location: "after",
					widget: "dxButton",
					options: {
						elementAttr: { class: "nautilus-fullscreenbutton" },
						hint: ko.computed(() => this.fullScreen() ? "Wiederherstellen" : "Maximieren"),
						icon: ko.computed(() => this.fullScreen() ? "collapse" : "expand"),
						onClick: () => {
							this.fullScreen(!this.fullScreen());
						}
					}
				}
			];
		}

		this.popupOptions = options;
		this.popupOptions.visible = this.isVisible;
	}

	public hide() {
		this.isVisible(false);
	}

	public show = () => {
		this.isVisible(true);
	}

	public waitUntilHidden = (): Promise<void> => {
		if (!this.isVisible()) {
			return Promise.resolve();
		}

		return new Promise((resolve, reject) => {
			let subscription = this.isVisible.subscribe((isVisible) => {
				if (!isVisible) {
					subscription.dispose();
					resolve();
				}
			});
		});
	}

	/** Called when popup becomes visible */
	protected abstract initialize(): void;

	protected onCancel() { }
}